import React from 'react';
import ReactECharts from 'echarts-for-react';

const AnalyticsView = () => {
  const funnelOption = {
    backgroundColor: 'transparent',
    tooltip: { trigger: 'item', formatter: '{a} <br/>{b} : {c}%' },
    series: [
      {
        name: 'Funnel',
        type: 'funnel',
        left: '10%',
        top: 60,
        bottom: 60,
        width: '80%',
        min: 0,
        max: 100,
        minSize: '0%',
        maxSize: '100%',
        sort: 'descending',
        gap: 2,
        label: { show: true, position: 'inside', formatter: '{b}: {c}', color: '#fff' },
        itemStyle: { borderColor: '#1e293b', borderWidth: 1 },
        data: [
          { value: 100, name: 'Sourced', itemStyle: { color: '#3b82f6' } },
          { value: 60, name: 'Applied', itemStyle: { color: '#6366f1' } },
          { value: 40, name: 'Screening', itemStyle: { color: '#8b5cf6' } },
          { value: 20, name: 'Interview', itemStyle: { color: '#a855f7' } },
          { value: 5, name: 'Offer', itemStyle: { color: '#22c55e' } }
        ]
      }
    ]
  };

  const lineOption = {
    backgroundColor: 'transparent',
    tooltip: { trigger: 'axis' },
    grid: { left: '3%', right: '4%', bottom: '3%', containLabel: true },
    xAxis: { type: 'category', boundaryGap: false, data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'], axisLine: { lineStyle: { color: '#475569' } } },
    yAxis: { type: 'value', axisLine: { lineStyle: { color: '#475569' } }, splitLine: { lineStyle: { color: '#1e293b' } } },
    series: [
      {
        name: 'Applications',
        type: 'line',
        stack: 'Total',
        smooth: true,
        lineStyle: { width: 3, color: '#3b82f6', shadowColor: 'rgba(59,130,246,0.5)', shadowBlur: 10 },
        areaStyle: { color: 'rgba(59,130,246,0.1)' },
        itemStyle: { color: '#3b82f6' },
        data: [120, 132, 101, 134, 90, 230, 210]
      }
    ]
  };

  return (
    <div className="p-6 max-w-7xl mx-auto space-y-6">
      <h1 className="text-2xl font-bold text-slate-100 flex items-center gap-2 mb-8">
        <span className="w-2 h-8 bg-indigo-500 rounded-full shadow-[0_0_10px_rgba(99,102,241,0.5)]"></span>
        Hiring Insights Data Core
      </h1>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <div className="bg-slate-900 border border-slate-800 rounded-xl p-5">
          <h2 className="text-lg font-semibold text-slate-200 mb-4">Conversion Funnel</h2>
          <div className="h-80">
            <ReactECharts option={funnelOption} style={{ height: '100%', width: '100%' }} />
          </div>
        </div>

        <div className="bg-slate-900 border border-slate-800 rounded-xl p-5">
          <h2 className="text-lg font-semibold text-slate-200 mb-4">Application Velocity</h2>
          <div className="h-80">
            <ReactECharts option={lineOption} style={{ height: '100%', width: '100%' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnalyticsView;